import { component } from 'picoapp';
import { throttle } from 'lodash';

interface Config {
  parallaxAmount: number
  parallaxOffset: number
}

export default component(async (node) => {
  const parallaxTargets = node.querySelectorAll<HTMLElement>('[data-parallax-target]');

  const configJson = node.querySelector<HTMLScriptElement>('[data-config]');
  const config: Config = JSON.parse(configJson.innerHTML);

  const { parallaxAmount } = config;
  const { parallaxOffset } = config;

  const DIVIDER = 0.01;

  const parallax = () => {
    let translateString = '';

    if (parallaxAmount === 0) {
      translateString = `translateY(-${parallaxOffset}%)`;
    } else {
      translateString = `translateY(calc(${node.getBoundingClientRect().top * DIVIDER + parallaxOffset} * -${parallaxAmount}%))`;
    }
    const translateValue = translateString;

    parallaxTargets.forEach((target) => {
      target.style.transform = translateValue;
    });
  };

  const init = () => {
    window.addEventListener('scroll', throttle(() => {
      parallax();
    }, 10));

    parallax();
  };

  init();
});
